// @flow

import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { Heading, Paragraph } from '@rover/kibble/components';
import { FontSize } from '@rover/kibble/styles';
import { ButtonType } from '@rover/react-lib/components/buttons/Button';
import LinkButton from '@rover/react-lib/components/buttons/LinkButton';
import PetDetailFieldView from '@rover/react-lib/pages/pets/PetProfilePage/components/CareInfo/PetDetailFieldView';
import type { Pet, PetDetailForDisplay } from '@rover/react-lib/types';
import { CareInstructionsConstants } from '@rover/shared/js/constants/translation';

type Props = {
  pet: Pet,
  hasMultiplePets: boolean,
  value: string,
  petDetails: Array<PetDetailForDisplay>,
};

const Wrapper: StyledComponent<{}> = styled.div`
  position: relative;
`;

const UpdateButton: StyledComponent<{}> = styled(LinkButton)`
  padding: 0;
  & > button {
    padding-left: 0;
  }
`;

const StyledPetDetailFieldView: StyledComponent<{}> = styled(PetDetailFieldView)`
  margin-top: 0;
  & * {
    font-size: ${FontSize.M};
  }
  & h4 {
    margin-bottom: 0 !important;
  }
`;

const CARE_INFO_SLUGS = [
  'potty-break',
  'energy-level',
  'feeding-schedule',
  'left-alone',
  'medication',
];

const CareInstruction = ({ pet, hasMultiplePets, value, petDetails }: Props): Node => {
  const inputId = `care-instructions-${pet.id}`;

  return (
    <Wrapper>
      {hasMultiplePets && (
        <Heading size="200" marginBottom="0x" textColor="primary">
          {pet.name}
        </Heading>
      )}
      <Paragraph marginBottom="1x">{value}</Paragraph>
      {petDetails.map((detail: PetDetailForDisplay) => {
        if (!CARE_INFO_SLUGS.includes(detail.slug)) {
          return null;
        }
        return (
          <StyledPetDetailFieldView
            key={`${inputId}-${detail.slug}`}
            petDetails={petDetails}
            slug={detail.slug}
          />
        );
      })}
      {/* $FlowFixMe */}
      <UpdateButton withBorder={false} buttonType={ButtonType.TEXT} href={pet.urls.editCare}>
        {CareInstructionsConstants.updateButton}
      </UpdateButton>
    </Wrapper>
  );
};

export default CareInstruction;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/CareInstructions/CareInstruction.jsx